import React from 'react';
import MessageBody from "./MessageBody";

export default () => {
  const header: string = 'Payment on the way!';
  const subtext: string = `Look for an email from payments@newtonx.com, it may have landed in your spam folder. Move the email to your inbox to enable the link and collect your payment. 

If there are any problems, please email us! We’re here to help at payments@newtonx.com.`
  return <MessageBody header={header} subtext={subtext} />
}